export default __webpack_public_path__ + "54d2c9092d93949bcc3d2ffaf0327543.png";